let baseState = () => {
  return {
    roles: [],
    newRole: {
      name: '',
      newName: '',
      description: ''
    },
    assignedPermissions: [],
    selectedPermissions: []
  }
}

const state = baseState()

export default state
export { baseState }
